module.exports = __webpack_public_path__ + "static/media/S4N9-4.4d346506.svg";